module.exports = "<div *ngIf=\"video\">\n    <h1 class=\"text-center\">{{video.name}}</h1>\n    <div class=\"d-flex justify-content-center\">\n        <div class=\"video-container\">\n            <videojs [url]=\"video.video.video\"></videojs>\n        </div>\n    </div>\n\n    <div class=\"text-center\">\n        <a href [routerLink]=\"['']\">Back To Main Page</a>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/gallery/video-detail/video-detail.component.html
// module id = ../../../../../src/app/gallery/video-detail/video-detail.component.html
// module chunks = main